const BASE_FONT_SIZE = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--font-base-size'), 10);

// eslint-disable-next-line import/prefer-default-export
export const toRem = (size = BASE_FONT_SIZE) => `${size / BASE_FONT_SIZE}rem`;
